import MDBox from "components/MDBox";
import { MatcherTableHeadersQuery } from "@/graphql/types/graphql";
import { FormControl, MenuItem, Select, Skeleton, Tooltip } from "@mui/material";
import colors from "assets/theme-dark/base/colors";

interface Props {
  identifier: string | null;
  onIdentifierSelect: (value: string) => void;
  matcherTableHeadersData: MatcherTableHeadersQuery;
}

export function TableOptions({ onIdentifierSelect, identifier, matcherTableHeadersData }: Props): JSX.Element {
  return (
    <FormControl fullWidth sx={{ minWidth: 120 }}>
      <Select
        value={identifier || ""}
        onChange={(e) => onIdentifierSelect(e.target.value)}
        displayEmpty
        sx={{
          backgroundColor: colors.secondary.main,
          borderRadius: 0,
          "& .MuiSelect-select": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "white",
          },
        }}
        size="small"
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
              maxWidth: 200,
              "& .MuiMenuItem-root": {
                color: colors.text.main,
                "&:hover": {
                  backgroundColor: colors.grey[700],
                  color: "white",
                },
              },
            },
          },
        }}
      >
        <MenuItem value="" disabled sx={{ color: colors.grey[500] }}>
          Select a header
        </MenuItem>
        {matcherTableHeadersData ? (
          matcherTableHeadersData.matcherTableHeaders
            ?.filter(
              (header) =>
                header !== "FX_UNIQUE_ID" && header !== "CUBEID" && header !== "SOURCEFILEID" && header !== "DATASETID"
            )
            .map((header) => (
              <MenuItem key={header} value={header}>
                {header.length >= 30 ? (
                  <Tooltip title={header} arrow placement="right">
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                      }}
                    >
                      {header}
                    </span>
                  </Tooltip>
                ) : (
                  <span>{header}</span>
                )}
              </MenuItem>
            ))
        ) : (
          <MDBox display="grid" gap={1}>
            <Skeleton
              variant="rectangular"
              height={32}
              style={{ marginTop: "1rem", backgroundColor: "rgba(255, 255, 255, 0.35)", borderRadius: "5px" }}
            />
            <Skeleton
              variant="rectangular"
              height={32}
              style={{ backgroundColor: "rgba(255, 255, 255, 0.35)", borderRadius: "5px" }}
            />
            <Skeleton
              variant="rectangular"
              height={32}
              style={{ backgroundColor: "rgba(255, 255, 255, 0.58)", borderRadius: "5px" }}
            />
          </MDBox>
        )}
      </Select>
    </FormControl>
  );
}
